export default __webpack_public_path__ + "static/media/triassicParkGate.13c78667.zip";